// AI-CONTEXT: See docs/features/livereport-widgets-housevisits-personas.md
// Single placeholder rendered by Housevisits / Personas widgets when their
// module is off on the current tenant, OR when the editor is in template-
// preview mode (template tenant doesn't have these modules seeded today),
// or when a whole-organisation widget sits in a report about one participant
// (PersonaScopeGuard, docs/features/livereport-per-deelnemer.md T5).
//
// The editor sidebar controls remain visible regardless — the editor can
// still configure the widget; it just won't render data until the right
// context loads.

const COPY = {
    template: 'Geen gegevens beschikbaar in template-modus.',
    persona: 'Deze widget telt over alle deelnemers en werkt niet in een rapportage per deelnemer.',
    disabledWithLabel: (label) => `Module ${label} niet ingeschakeld voor deze organisatie.`,
    disabledNoLabel: 'Module niet ingeschakeld voor deze organisatie.',
}

/**
 * @param {object} props
 * @param {'template' | 'disabled' | 'persona'} props.mode - Which message to render ('persona' = whole-organisation widget in a report about one participant)
 * @param {string} [props.moduleLabel] - Display label inserted into the disabled message (e.g. "Huishoudens")
 * @returns {JSX.Element}
 */
const ModulePlaceholder = ({ mode, moduleLabel }) => {
    const message = mode === 'template'
        ? COPY.template
        : mode === 'persona'
            ? COPY.persona
            : (moduleLabel ? COPY.disabledWithLabel(moduleLabel) : COPY.disabledNoLabel)

    return (
        <div
            className="module-placeholder"
            data-testid="module-placeholder"
            data-mode={mode}
        >
            <p className="module-placeholder-message">{message}</p>
        </div>
    )
}

export default ModulePlaceholder
